import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Box, Typography } from '@mui/material';

const ChatMessage = ({ content, isUser, isTyping = false }) => {
  if (isTyping) {
    return (
      <Box
        sx={{
          alignSelf: 'flex-start',
          backgroundColor: '#f7f7f8',
          color: '#666',
          padding: '14px 18px',
          borderRadius: '14px',
          maxWidth: '75%',
          fontSize: '14px',
          fontStyle: 'italic'
        }}
      >
        Phoenix AI is typing…
      </Box>
    );
  }

  return (
    <Box
      sx={{
        alignSelf: isUser ? 'flex-end' : 'flex-start',
        backgroundColor: isUser ? '#8b2c2c' : '#f7f7f8',
        color: isUser ? '#ffffff' : '#111111',
        padding: '16px 18px',
        borderRadius: '14px',
        maxWidth: '75%',
        fontSize: '15px',
        lineHeight: 1.75
      }}
      //   sx={{
      //     maxWidth: '720px',
      //     px: 2.5,
      //     py: 2,
      //     borderRadius: 2,
      //     bgcolor: isUser ? '#8b2c2c' : 'rgba(0,0,0,0.02)',
      //     color: isUser ? '#ffffff' : 'rgba(0,0,0,0.85)'
      //   }}
    >
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          h2: ({ children }) => (
            <Typography
              variant="h5"
              sx={{
                mt: 3,
                mb: 1.5,
                fontWeight: 600,
                lineHeight: 1.3
              }}
            >
              {children}
            </Typography>
          ),

          h3: ({ children }) => (
            <Typography
              variant="subtitle1"
              sx={{
                mt: 2,
                mb: 1,
                fontWeight: 600,
                lineHeight: 1.4
              }}
            >
              {children}
            </Typography>
          ),

          p: ({ children }) => (
            <Typography
              variant="body1"
              sx={{
                mb: 1.5,
                lineHeight: 1.75
              }}
            >
              {children}
            </Typography>
          ),

          li: ({ children }) => (
            <li style={{ marginBottom: '6px' }}>
              <Typography component="span" variant="body1" sx={{ lineHeight: 1.75 }}>
                {children}
              </Typography>
            </li>
          )
        }}
      >
        {content}
      </ReactMarkdown>
    </Box>
  );
};

export default ChatMessage;
